import { render, staticRenderFns } from "./EingabeWerte.vue?vue&type=template&id=2bde4b56&scoped=true&"
import script from "./EingabeWerte.vue?vue&type=script&lang=js&"
export * from "./EingabeWerte.vue?vue&type=script&lang=js&"
import style0 from "./EingabeWerte.vue?vue&type=style&index=0&id=2bde4b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde4b56",
  null
  
)

export default component.exports